import { createContext, useContext } from "react";

/**
 * Branding resolvido pelo backend (`GET /api/branding`) a partir do Host header.
 * Multi-tenant white label: o mesmo bundle serve N marcas diferentes.
 * Campos opcionais podem vir nulos do endpoint (ver fallback em DEFAULT_BRAND).
 */
export interface Brand {
  host: string;
  nome_produto: string;
  nome_curto: string;
  cor_primaria: string;
  cor_secundaria: string | null;
  theme_color: string;
  logo_url: string;
  logo_white_url: string;
  logo_small_url: string;
  favicon_url: string;
  apple_touch_url: string | null;
  meta_description: string | null;
  meta_keywords: string | null;
  lang: string;
  suporte_email: string | null;
  suporte_whatsapp: string | null;
}

const BrandContext = createContext<Brand | null>(null);

export const BrandProvider = BrandContext.Provider;

export function useBrand(): Brand {
  const b = useContext(BrandContext);
  if (!b) {
    throw new Error("useBrand precisa estar dentro de <BrandProvider>");
  }
  return b;
}
